import { Button as MuiButton } from '@mui/material';
import { buttonClasses, ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';

import { tokens } from '../../theme/styles/themeMui';

export type { ButtonProps };

export const Button: React.ComponentType<ButtonProps> = styled(MuiButton)<ButtonProps>(
  ({ theme, size, color }) => ({
    [`&.${buttonClasses.root}`]: {
      textTransform: 'none',
      borderRadius: '100px',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      ...(color === 'primary' && {
        color: `${theme.palette.colors.static.content['key-light']}`,
      }),
      ...(color === 'secondary' && {
        color: `${theme.palette.colors.content.primary}`,
      }),
      ...(color === 'danger' && {
        color: `${theme.palette.colors.static.content['key-light']}`,
      }),
      ...(color === 'tertiary' && {
        color: `${theme.palette.colors.content.primary}`,
      }),
      ...(color === 'floating' && {
        color: `${theme.palette.colors.content.primary}`,
        backgroundColor: `${theme.palette.colors.core.white}`,
        boxShadow: `0 0 1px 1px rgba(26, 27, 35, 0.04), 0 8px 8px 0 rgba(26, 27, 35, 0.06), 0 8px 8px -8px rgba(26, 27, 35, 0.24)`,
        [`&:hover`]: {
          boxShadow:
            '0 0 1px 1px rgba(26, 27, 35, 0.04), 0 2px 2px 0 rgba(26, 27, 35, 0.06), 0 2px 2px -2px rgba(26, 27, 35, 0.24)',
        },
      }),
      ...(color === 'static-light' && {
        color: `${theme.palette.colors.static.content['key-dark']}`,
        backgroundColor: `${theme.palette.colors.static.bg['key-light']}`,
        [`&:hover`]: {
          backgroundColor: `${theme.palette.colors.static['bg-active']['key-light']}`,
        },
      }),
    },
    [`&:active`]: {
      transition: 'ease-in-out 0.1s',
      transform: 'scaleX(0.975) scaleY(0.975)',
    },
    [`&.${buttonClasses.disabled}.${buttonClasses.loading}`]: {
      backgroundColor: 'var(--variant-containedBg)',
      color: 'var(--variant-containedBg)',
    },
    [`.${buttonClasses.loadingIndicator}`]: {
      color: 'var(--variant-containedColor)',
    },
    [`.${buttonClasses.startIcon}`]: {
      marginRight: 0,
    },
    [`.${buttonClasses.endIcon}`]: {
      marginLeft: 0,
    },

    ...(color === 'secondary' && {
      [`&.${buttonClasses.disabled}.${buttonClasses.loading}`]: {
        color: 'rgba(0,0,0,0)',
      },
    }),

    ...(color === 'tertiary' && {
      [`&.${buttonClasses.disabled}.${buttonClasses.loading}`]: {
        backgroundColor: theme.palette.tertiary.dark,
        color: 'rgba(0,0,0,0)',
      },
    }),

    ...(color === 'static-light' && {
      [`&.${buttonClasses.disabled}`]: {
        color: `${theme.palette.colors.content.tertiary}`,
        backgroundColor: `${theme.palette.colors.core.white}`,
      },
      [`&.${buttonClasses.disabled}.${buttonClasses.loading}`]: {
        color: 'rgba(0,0,0,0)',
      },
      [`.${buttonClasses.loadingIndicator}`]: {
        color: `${theme.palette.colors.content.primary}`,
      },
    }),

    ...(color === 'floating' && {
      [`&.${buttonClasses.disabled}`]: {
        color: `${theme.palette.colors.content.tertiary}`,
      },
      [`&.${buttonClasses.disabled}.${buttonClasses.loading}`]: {
        color: 'rgba(0,0,0,0)',
      },
      [`.${buttonClasses.loadingIndicator}`]: {
        color: `${theme.palette.colors.content.primary}`,
      },
    }),
    ...(size === 'large' && {
      padding: '16px 24px',
      ...tokens.typography['body-l-accent'],
    }),
    ...(size === 'medium' && {
      padding: '12px 24px',
      ...tokens.typography['body-m-accent'],
    }),
    ...(size === 'small' && {
      padding: '8px 16px',
      ...tokens.typography['body-s-accent'],
    }),
  }),
);
